import {
  DetailsCard,
  LegislationEntry,
  Mtds,
  ScalesIcon,
  usePlanLegislation
} from 'prove-common'

export function TaskLegislationCard({ planId }: Readonly<{ planId: number }>) {
  const entries = usePlanLegislation(planId)

  return (
    <DetailsCard title='Regelverk' icon={<ScalesIcon aria-hidden />}>
      {entries.isPending && <p role='status'>Laster regelverk…</p>}
      {entries.isSuccess && entries.data.length === 0 && (
        <p>Ingen regelverk er lagt til.</p>
      )}
      {entries.isError && (
        <Mtds.Alert data-color='danger' role='alert'>
          <Mtds.Grid>
            <p>Kunne ikke laste regelverket.</p>
            <Mtds.Button
              type='button'
              data-variant='secondary'
              data-justify-self='start'
              onClick={() => void entries.refetch()}
            >
              Prøv igjen
            </Mtds.Button>
          </Mtds.Grid>
        </Mtds.Alert>
      )}
      {!!entries.data?.length && (
        <>
          <p>Prøvetakingen er hjemlet i dette regelverket.</p>
          <Mtds.Grid data-gap='6'>
            {entries.data.map((entry) => (
              <LegislationEntry key={entry.id} entry={entry} />
            ))}
          </Mtds.Grid>
        </>
      )}
    </DetailsCard>
  )
}
